var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"cursor--order",attrs:{"light":""}},[_c('v-card-text',[_c('p',{staticClass:"body-1 font-weight-regular",domProps:{"innerHTML":_vm._s(_vm.card.message)}}),_c('v-chip',[_vm._v(_vm._s(_vm.order))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }